var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#D1D1D1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3705_16890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4592 22.5108C28.1841 22.5108 27.9611 22.7338 27.9611 23.0089V27.4315C27.9601 28.2565 27.2918 28.925 26.4668 28.9258H12.4905C11.6655 28.925 10.9972 28.2565 10.9962 27.4315V14.4515C10.9972 13.6266 11.6656 12.9581 12.4905 12.9571H16.9132C17.1883 12.9571 17.4113 12.7341 17.4113 12.459C17.4113 12.1841 17.1883 11.9609 16.9132 11.9609H12.4905C11.1157 11.9625 10.0015 13.0766 10 14.4515V27.4317C10.0015 28.8065 11.1157 29.9207 12.4905 29.9223H26.4668C27.8416 29.9207 28.9558 28.8065 28.9573 27.4317V23.0089C28.9573 22.7338 28.7343 22.5108 28.4592 22.5108Z",
    fill: "#082572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7617 10.68C27.8863 9.8046 26.4671 9.8046 25.5918 10.68L16.7052 19.5665C16.6444 19.6273 16.6003 19.7028 16.5774 19.7857L15.4088 24.0047C15.3852 24.0896 15.3846 24.1793 15.407 24.2646C15.4294 24.3498 15.4741 24.4276 15.5364 24.4899C15.5987 24.5523 15.6765 24.597 15.7618 24.6194C15.847 24.6419 15.9367 24.6413 16.0216 24.6177L20.2406 23.4489C20.3235 23.426 20.399 23.382 20.4598 23.3211L29.3461 14.4345C30.2201 13.5585 30.2201 12.1405 29.3461 11.2645L28.7617 10.68ZM17.7905 19.8902L25.0635 12.6171L27.409 14.9627L20.1359 22.2358L17.7905 19.8902ZM17.322 20.8304L19.1959 22.7045L16.6038 23.4227L17.322 20.8304ZM28.6418 13.7301L28.1136 14.2583L25.7678 11.9125L26.2963 11.3843C26.7825 10.898 27.5709 10.898 28.0571 11.3843L28.6418 11.9688C29.1273 12.4556 29.1273 13.2435 28.6418 13.7301Z",
    fill: "#082572"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3705_16890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.08c83cc2087b1dd37aa643aac2680ce4.svg";
export { ForwardRef as ReactComponent };